import { render } from "./TaxExemptStatusView.vue?vue&type=template&id=64dc747d&scoped=true&lang=pug"
import script from "./TaxExemptStatusView.vue?vue&type=script&lang=js"
export * from "./TaxExemptStatusView.vue?vue&type=script&lang=js"

import "./TaxExemptStatusView.vue?vue&type=style&index=0&id=64dc747d&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dc747d"]])

export default __exports__